import React from "react";
import PointOfSaleCore from "../../Core/index";
import RestaurantPreorder from "./Preorder";
import ModuleGate from "../../../ModuleGate";

const Preorder = () => (
  <ModuleGate module="restaurantPreorder">
    <PointOfSaleCore component={RestaurantPreorder} />
  </ModuleGate>
);

export default Preorder;
